import { Service } from '../../types';

interface MetadataOptions {
  city?: string;
  state?: string;
  brand?: string;
  service?: Service;
}

export function generateMetadata({ city, state, brand, service }: MetadataOptions) {
  const location = city && state ? `in ${city}, ${state}` : '';
  const brandPrefix = brand ? `${brand} ` : '';
  const serviceType = service?.name || 'Appliance Repair';
  const phoneNumbers = 'Call 9828351602, 8559929954';

  return {
    title: `${brandPrefix}${serviceType} ${location} - ${phoneNumbers} | Parakh Services`,
    description: `Professional ${brandPrefix.toLowerCase()}${serviceType.toLowerCase()} services ${location}. Expert technicians, same-day service, and 90-day warranty. ${phoneNumbers}!`,
    keywords: generateKeywords({ city, state, brand, service }),
  };
}

function generateKeywords({ city, state, brand, service }: MetadataOptions): string[] {
  const keywords = [];
  const serviceType = service?.name.toLowerCase() || 'appliance repair';
  const location = city ? `${city}${state ? `, ${state}` : ''}` : '';
  const phoneNumbers = ['9828351602', '8559929954'];

  // Base keywords
  keywords.push(
    serviceType,
    `${serviceType} services`,
    'repair services',
    'appliance repair',
    ...phoneNumbers
  );

  // Location-based keywords
  if (location) {
    keywords.push(
      `${serviceType} in ${location}`,
      `${serviceType} services ${location}`,
      `best ${serviceType} ${location}`,
      `${serviceType} near me ${location}`,
      `${serviceType} cost ${location}`,
      `emergency ${serviceType} ${location}`,
      ...phoneNumbers.map(phone => `${serviceType} ${location} ${phone}`)
    );
  }

  // Brand-specific keywords
  if (brand) {
    keywords.push(
      `${brand} ${serviceType}`,
      `${brand} repair`,
      `${brand} service center`,
      `${brand} authorized service`,
      ...phoneNumbers.map(phone => `${brand} ${serviceType} ${phone}`)
    );
  }

  return keywords;
}